import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-text-viewer',
  templateUrl: './text-viewer.component.html',
  styleUrls: ['./text-viewer.component.scss']
})
export class TextViewerComponent implements OnInit {
  private static white = '#ffffff';
  private static black = '#2b2b2b';
  @Input() data;
  fontSize = 1;
  background: string;
  textColor: string;
  private originalText: string;
  cursor: any;

  constructor() {
  }

  ngOnInit() {
    this.fontSize = 1;
    this.background = TextViewerComponent.white;
    this.textColor = TextViewerComponent.black;
    this.cursor = 'default';
  }

  decrease() {
    if (this.fontSize > 0.5) {
      this.fontSize -= 0.5;
    }
  }

  increase() {
    if (this.fontSize < 6) {
      this.fontSize += 0.5;
    }
  }

  resetTool() {
    this.fontSize = 1;
    this.background = TextViewerComponent.white;
    this.textColor = TextViewerComponent.black;
    // this.data = this.originalText; // commented to fix issue with Manual Upload CR TXT viewer
    this.cursor = 'default';
  }

  backgroundTool() {
    if (TextViewerComponent.black === this.background) {
      this.background = TextViewerComponent.white;
      this.textColor = TextViewerComponent.black;
    } else {
      this.background = TextViewerComponent.black;
      this.textColor = TextViewerComponent.white;
    }
  }

  selectedText() {
    this.originalText = this.data; // save it fix issue with Manual Upload CR TXT viewer
    if ('pen' === this.cursor) {
      if (typeof window.getSelection !== 'undefined') {
        const text = window.getSelection().toString();
        if (text) {
          const index = this.originalText.indexOf(text);
          if (index >= 0) {
            this.data = this.originalText.substring(0, index)
              + '<mark>' + this.originalText.substring(index, index + text.length) + '</mark>'
              + this.originalText.substring(index + text.length);
          }
        }
      }
    }
  }

  highlighter() {
    this.cursor = 'pen';
  }
}
